import { findValeValido, findValesPresentesByVendaId, enviarValePresentePorWhatsapp, findValesPresentesByVendaIdPublico } from "@/api/valepresente"
import { ValePresenteServiceAdapter } from "@/usecases/valepresente/adapter"
import { injectable } from "inversify"

@injectable()
export class ValePresenteService implements ValePresenteServiceAdapter{
	findValeValido = async (identificador: string, grupoEconomicoId: string) => await findValeValido(identificador, grupoEconomicoId)	
	findValesPresentesByVendaId = async (vendaId: string) => await findValesPresentesByVendaId(vendaId)
	enviarValePresentePorWhatsapp = async (vendaId: string) => await enviarValePresentePorWhatsapp(vendaId)
	findValesPresentesByVendaIdPublico = async (vendaId: string) => await findValesPresentesByVendaIdPublico(vendaId)
}